import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-celebrating-yoga-day',
  templateUrl: './celebrating-yoga-day.component.html',
  styleUrls: ['./celebrating-yoga-day.component.scss']
})
export class CelebratingYogaDayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
